import React from 'react';

interface NotificationBellProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  count?: number;
  className?: string;
}

const NotificationBell = React.forwardRef<HTMLButtonElement, NotificationBellProps>(
  ({ count = 0, className = '', ...props }, ref) => {
    return (
      <button
        type="button"
        ref={ref}
        className={`relative flex h-8 w-8 items-center justify-center rounded-full p-0 text-white/70 transition-colors duration-150 hover:bg-white/10 hover:text-white focus:outline-none ${className}`}
        aria-label="Notifications"
        {...props}
      >
        {/* Bell Icon SVG */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
          />
        </svg>
        {/* Badge */}
        {count > 0 && (
          <span
            className="absolute top-0 right-0 flex h-4 w-auto min-w-[1rem] items-center justify-center rounded-full bg-red-500 px-0.5 text-[10px] font-medium text-white"
            aria-label={`${count} unread notifications`}
          >
            {count > 99 ? '99+' : count}
          </span>
        )}
      </button>
    );
  }
);

NotificationBell.displayName = 'NotificationBell';

export default NotificationBell;
